var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"th-footer"},[_c('WFIcon',{attrs:{"name":"clock"}}),_c('div',{staticClass:"opening-hours",attrs:{"data-translation-element":"opening-hours"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }